import { authStatus } from '../action/Status';

const initialData = {
	token: null,
	user: [],
	authenticate: false,
	authenticating: false,
	loading: false,
	error: null,
	message: ""
};

const authReducer = (state = initialData, action) => {
	switch (action.type) {
		case authStatus.LOGIN_REQUEST:
			return {
				...state,
				authenticating: true
			};
		case authStatus.LOGIN_SUCCESS:
			return {
				...state,
				user: action.payload.user,
				token: action.payload.token,
				authenticate: true,
				authenticating: false
			};
		default:
			return state;
	}
};

export default authReducer;
